<template>
    <div v-bind:class="{
        'blue-mode': mode === MASECHET_MODE,
        'grey-mode': mode === DEFAULT_MODE,
        'dedication-day-mode': mode === DEDICATION_REASON_MODE,
        'cart-mode': mode === CART_MODE,
    }">
        <div class="container" v-on:click="toggleDropdownState()" ref="container">
            <div class="layout">
                <div class="content-area">
                    <div>
                        <header>
                            <div v-if="selectedItem" class="item header">
                                <span>{{selectedItem}}</span>
                            </div>
                            <div v-else class="item header">
                                <span>{{pristineText}}</span>
                            </div>
                        </header>
                    </div>
                </div>
                <div class="indicator">
                <span>
                    <font-awesome-icon :icon="['fal', 'angle-down']"/>
                </span>
                </div>
            </div>
        </div>
        <div class="dropdown-container">
            <transition name="ease">
                <div v-if="dropdownShowing" class="dropdown-menu">
                    <div v-for="item in data">
                        <div class="item" v-on:click="selectItem(item)">
                            <span>{{item}}</span>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>

    import {
        DEFAULT_MODE,
        MASECHET_MODE,
        DEDICATION_REASON_MODE,
        DROPDOWN_CART_MODE,
    } from '../services/constants'

    const SELECT_EVENT = 'jbr-select'
    export default {
        name: 'jabra-dropdown',
        props: {
            data: {
                type: Array,
                default: () => []
            },
            initialSelectedItem: {
                type: String,
                default: null,
            },
            mode: {
                type: Number,
                default: DEFAULT_MODE,
            },
        },
        data: function () {
            return {
                dirty: false,
                dropdownShowing: false,
                dropdownCellWidth: 208,
                selectedItem: this.initialSelectedItem,
                DEFAULT_MODE: DEFAULT_MODE,
                MASECHET_MODE: MASECHET_MODE,
                DEDICATION_REASON_MODE: DEDICATION_REASON_MODE,
                CART_MODE: DROPDOWN_CART_MODE,
            }
        },
        computed: {
            pristineText() {
                return this.mode === MASECHET_MODE ? 'Select Masechet' : 'Select Size'
            },
        },
        methods: {
            toggleDropdownState() {
                this.dropdownShowing = !this.dropdownShowing
            },
            prepareRuntimeSize() {
                this.dropdownCellWidth = this.$refs.container.clientWidth
            },
            selectItem(item) {
                this.dropdownShowing = false
                this.selectedItem = item
                this.$emit(SELECT_EVENT, this.selectedItem)
            },
        },
        mounted() {
            this.prepareRuntimeSize()
        },
        created() {
            if (this.selectedItem) {
                this.selectItem(this.selectedItem)
            } else {
                if (this.mode === MASECHET_MODE && this.data.length > 0) {
                    this.selectItem(this.data[0])
                } else {
                    this.selectItem(this.selectedItem)
                }
            }
        }

    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    $container-padding: 20px;
    $blue-mode-width: 357px;
    .blue-mode {
        @include font-abraham(30px, $font-color-blue, 400);
        .container {
            width: $blue-mode-width;
        }
        .dropdown-menu {
            width: $blue-mode-width + $container-padding * 2;
        }
    }

    $grey-mode-width: 125px;
    .grey-mode {
        @include font-abraham(18px, $grey-1, 400);

        .container {
            width: $grey-mode-width;
        }
        .dropdown-menu {
            width: $grey-mode-width + $container-padding * 2;
        }
    }

    $dedication-day-mode-width: 200px;
    $dedication-day-mode-bg-color: rgb(238, 238, 238);
    .dedication-day-mode {
        @include font-abraham(22px, $font-color-blue, 300);

        .container {
            width: $dedication-day-mode-width;
            background: $dedication-day-mode-bg-color;
        }
        .dropdown-menu {
            width: $dedication-day-mode-width + $container-padding * 2;
        }
        .item {
            background-color: $dedication-day-mode-bg-color;
        }
    }

    .cart-mode {
        .item {
            height: 40px;
            padding: 5px 15px;
            display: flex;
            align-items: center;
        }
        $cart-container-padding: $container-padding;
        $cart-mode-width: $grey-mode-width;
        .container {
            width: $cart-mode-width;
        }
        .dropdown-menu {
            width: $cart-mode-width + $cart-container-padding * 2;
        }

    }

    .container {
        border: #cccccc solid 1px;
        background: #ffffff;
        cursor: pointer;
        line-height: 27px;
        padding: 0 $container-padding;
    }

    .layout {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 100%;
    }

    .ease-enter-active {
        top: 0;
        opacity: 1;
        transition: opacity 0.2s, top 0.2s;
    }

    .ease-leave-active {
        top: 0;
        opacity: 1;
        transition: opacity 0.2s, top 0.2s;
    }

    .ease-enter, .ease-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
        top: -10px;
    }

    .dropdown-container {
        position: relative;
    }

    .dropdown-menu {
        position: absolute;
        box-shadow: 0 3px 5px -2px $grey-2;
        z-index: 1;
        max-height: 50vh;
        overflow-y: scroll;
    }

    .item {
        padding: 15px;
        cursor: pointer;
        background-color: #ffffff;
        &:hover:not(.header) {
            background-color: $hover-color-grey;
            transition: background-color .2s;

        }
    }


</style>
